import React, { useState, useEffect } from "react";
import MegaMenuServices from "./MegaMenuServices";
import "../styles/Navbar.css";
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const DropdownToggle = ({ label }) => (
  <span className="navbar__dropdown-toggle">
    {label}
    <span className="navbar__chevron"></span>
  </span>
);

function Navbar() {
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showMegaMenu, setShowMegaMenu] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLang);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMenuOpen(false);
        setShowMegaMenu("");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToPageTop = () => {
    document.documentElement.scrollTop = 0; 
    document.body.scrollTop = 0;        
    window.scrollTo({
      top: 0,
      behavior: 'smooth' 
    });
  };

  const handleLinkClick = () => {
    if (isMobile) {
      setMenuOpen(false);
    }
    scrollToPageTop();
  };

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen && isMobile) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen, isMobile]);

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <Link to="/" className="navbar__logo" onClick={handleLinkClick}> 
        <img src="/images/logo.png" alt="Future Forbes Logo" />
      </Link>
      <Link to="/" className="navbar__company" onClick={handleLinkClick}> 
        Future Forbes
      </Link>

      {isMobile ? (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <button onClick={toggleLanguage} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-color)', padding: 0, display: 'flex', alignItems: 'center', gap: '4px' }} aria-label="Toggle Language">
              <Globe size={20} />
              <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{i18n.language.toUpperCase()}</span>
            </button>
            <div
              className={`navbar__hamburger ${menuOpen ? "open" : ""}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </div>
          </div>

          {menuOpen && (
            <div className="navbar__mobile-menu">
              <Link to="/" onClick={handleLinkClick}> {t('navbar.home', 'Home')} </Link>
              <Link to="/products" onClick={handleLinkClick}> {t('navbar.products', 'Products')} </Link>
              <Link to="/services" onClick={handleLinkClick}> {t('navbar.services', 'Services')} </Link>
              <Link to="/insights" onClick={handleLinkClick}> {t('navbar.insights', 'Insights')} </Link>
              <Link to="/about" onClick={handleLinkClick}> {t('navbar.company', 'About Us')} </Link>
              <Link to="/careers" onClick={handleLinkClick}> {t('navbar.careers', 'Careers')} </Link>
              <Link
                to="/contactus"
                className="navbar__contact-button navbar__contact-button--mobile"
                onClick={handleLinkClick}
              >
                {t('navbar.contact', 'Contact Us')}
              </Link>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="navbar__links">
            <Link to="/" onClick={handleLinkClick}> {t('navbar.home', 'Home')} </Link> 
            <Link to="/products" onClick={handleLinkClick}> {t('navbar.products', 'Products')} </Link> 
            <div
              className="navbar__dropdown"
              onMouseEnter={() => setShowMegaMenu("services")}
              onMouseLeave={() => setShowMegaMenu("")}
            >
              <Link to="/services" onClick={handleLinkClick}>
                <DropdownToggle label={t('navbar.services', 'Services')} />
              </Link>
              {showMegaMenu === "services" && (
                <MegaMenuServices scrolled={scrolled} />
              )}
            </div>
            <Link to="/insights" onClick={handleLinkClick}>{t('navbar.insights', 'Insights')}</Link>
            <Link to="/about" onClick={handleLinkClick}>{t('navbar.company', 'About Us')}</Link>
            <Link to="/careers" onClick={handleLinkClick}>{t('navbar.careers', 'Careers')}</Link>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <button onClick={toggleLanguage} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-color)', padding: 0, display: 'flex', alignItems: 'center', gap: '6px' }} aria-label="Toggle Language">
              <Globe size={20} />
              <span style={{ fontSize: '14px', fontWeight: 'bold' }}>{i18n.language.toUpperCase()}</span>
            </button>
            <Link to="/contactus" className="navbar__contact-button" onClick={handleLinkClick}>
              {t('navbar.contact', 'Contact Us')}
            </Link>
          </div>
        </>
      )}
    </nav>
  );
}

export default Navbar;